import { render } from "./copyProcessToOthersModal.vue?vue&type=template&id=73149560&scoped=true&ts=true"
import script from "./copyProcessToOthersModal.vue?vue&type=script&lang=ts"
export * from "./copyProcessToOthersModal.vue?vue&type=script&lang=ts"

import "./copyProcessToOthersModal.vue?vue&type=style&index=0&id=73149560&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73149560"]])

export default __exports__